import React, { useState } from "react"
import { useLingui } from "@lingui/react"
import PropTypes from "prop-types"
import { dynamiclyActivate } from "../../i18n"

const languages = [
  { value: "en", label: "English" },
  { value: "fr", label: "Francais" },
  { value: "sw", label: "Kiswahili" },
  { value: "lb", label: "LEBANESE ENGLISH" },
  { value: "ar", label: "العربية" },
  { value: "pt", label: "PORTUGUESE" },
  { value: "es", label: "Español" },
]

const LangSelector = (props) => {
  const { i18n } = useLingui()
  const [lang, setLang] = useState(i18n.locale)

  const onChange = (e) => {
    const locale = e.target.value
    localStorage.setItem("lang", locale)
    dynamiclyActivate(locale)
    setLang(locale)
    props.toggleBack()
  }

  return (
    <div>
      {languages.map((language, index) => (
        <div
          className="form-check"
          key={language.value}
          style={{ direction: i18n.locale === "ar" ? "rtl" : "ltr" }}
        >
          <input
            className="form-check-input"
            type="radio"
            name="languageRadios"
            id={`languageRadio${index}`}
            onChange={onChange}
            value={language.value}
            checked={language.value === lang}
          />
          <label
            className="form-check-label"
            htmlFor={`languageRadio${index}`}
            style={{ fontFamily: "Fira Sans", fontSize: "16px" }}
          >
            {language.label}
          </label>
        </div>
      ))}
    </div>
  )
}

LangSelector.propTypes = {
  toggleBack: PropTypes.func,
}

export default LangSelector
